import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@ds/lib/utils";

/**
 * Badge — penanda state ringkas. Anti "warna saja": sertakan `icon` atau
 * teks bermakna pada state kritis (PRODUCT.md a11y, rfc-006 §7).
 */
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap [&>svg]:size-3.5",
  {
    variants: {
      variant: {
        neutral: "bg-surface-2 text-ink border-border",
        primary: "bg-primary-soft text-primary border-transparent",
        success: "bg-success-soft text-success border-transparent",
        warn: "bg-warn-soft text-warn-ink border-transparent",
        danger: "bg-danger-soft text-danger border-transparent",
        info: "bg-info-soft text-info border-transparent",
        outline: "bg-transparent text-ink border-border-strong",
      },
      size: {
        sm: "h-5 px-2 text-[0.6875rem]",
        md: "h-6 px-2.5 text-xs",
      },
    },
    defaultVariants: { variant: "neutral", size: "md" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
}

export function Badge({
  className,
  variant,
  size,
  icon,
  children,
  ...props
}: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {icon}
      {children}
    </span>
  );
}

export { badgeVariants };
